/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { addressInfoDisplayStyles } from "@monsma/Overrides/Components/AddressInfoDisplay";
import { css } from "styled-components";

addressInfoDisplayStyles.wrapper = {
    css: css`
        font-style: normal;

        &&& a span,
        p {
            font-size: 13px;
            letter-spacing: 0;
            line-height: 22px;
            font-weight: normal;
        }
    `,
};

addressInfoDisplayStyles.companyNameText = {
    variant: "h6",
    css: css`
        font-style: normal;
        display: block;

        &,
        p {
            font-size: 14px;
            letter-spacing: 0;
            line-height: 20px;
            margin-bottom: 10px;
            font-weight: bold;
            text-transform: capitalize;
        }

        &.add-top-margin {
            margin-top: 5px;
        }
    `,
};

export { addressInfoDisplayStyles };
